import React from 'react'
import PropTypes from 'prop-types'
import './Review.sass'
import Review from './Components/Review'

const ReviewList = ({ data }) => {
  const id = new Date().getTime().toString()
  return (
    <div className='reviews'>
      {data.map(({ rating, time, reviewer, review }, i) => (
        <Review
          key={'review' + id + i}
          rating={rating}
          time={time}
          reviewer={reviewer}
          review={review}
        />
      ))}
    </div>
  )
}

ReviewList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      rating: PropTypes.number.isRequired,
      time: PropTypes.number.isRequired,
      reviewer: PropTypes.shape({
        name: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      }),
      review: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default ReviewList
